import { render, staticRenderFns } from "./SubCategoryUsefulLinks.vue?vue&type=template&id=1c075cc1&scoped=true&"
import script from "./SubCategoryUsefulLinks.vue?vue&type=script&lang=js&"
export * from "./SubCategoryUsefulLinks.vue?vue&type=script&lang=js&"
import style0 from "./SubCategoryUsefulLinks.vue?vue&type=style&index=0&id=1c075cc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c075cc1",
  null
  
)

export default component.exports